<template>
	<div class="vcx-news-carousel">
		<hr class="vcx-divider-dark vcx-mt-500 vcx-pt-50" />

		<div class="vcx-flex vcx-justify-between vcx-items-center">
			<h3 class="vcx-label-md">{{ title }}</h3>
			<BaseLink
				:link="{
					router: 'blog-category',
					params: { categoryUrlSlug: blogCategorySlug }
				}"
				classes="vcx-button-ghost"
			>
				View All <span class="show-for-sr">news articles in the {{ title }} category</span>
			</BaseLink>
		</div>
		<div class="vcx-grid">
			<p class="vcx-col-10 vcx-body-md vcx-text-tertiary vcx-mt-0 vcx-display-none-smo vcx-pr-500">{{
				description
			}}</p>
		</div>

		<VcxHorizontalScroll class="vcx-mt-300">
			<template #scroll-items>
				<template v-if="isVcxSanityLoading">
					<li v-for="index in 3" :key="`${blogCategorySlug}-placeholder-${index}`" aria-hidden="true">
						<div class="vcx-placeholder-card"></div>
					</li>
				</template>
				<slot v-else name="scroll-items" />
			</template>
		</VcxHorizontalScroll>
	</div>
</template>

<script setup lang="ts">
import { inject, ref } from 'vue';
import VcxHorizontalScroll from '@components/vcx/vcx-horizontal-scroll.vue';

interface Props {
	title: string;
	description: string;
	blogCategorySlug: string;
}

defineProps<Props>();

const isVcxSanityLoading = inject('isVcxSanityLoading', ref(false));
</script>

<style lang="scss" scoped>
@use '../../styles/vcx/responsive' as *;

.vcx-news-carousel {
	:deep(.vcx-placeholder-card) {
		border-radius: var(--vcx-radius-50);
		width: 400px;
		height: 350px;
		background-image: linear-gradient(
			to right,
			rgba(255, 255, 255, 0.05),
			rgba(255, 255, 255, 0.1) 50%,
			rgba(255, 255, 255, 0.05)
		);
		animation: vcx-card-placeholder 0.75s infinite linear;

		@include vcx-media-smo {
			width: 320px;
		}
	}

	@keyframes vcx-card-placeholder {
		0% {
			background-position: 0 0;
		}
		100% {
			background-position: 400px 0;
		}
	}
}
</style>
